import React from 'react';
import classNames from 'classnames';
import animation from './animation.module.scss';
import styles from './CartUploadAnimation.module.scss';

export const CartUploadAnimation = ({ className }: Props) => (
    <svg className={classNames(styles.icon, className)}
        viewBox='0 0 24 24' strokeLinecap='round' strokeLinejoin='round'>
        <circle cx='6' cy='19' r='2' />
        <circle cx='17' cy='19' r='2' />
        <path d='M17,17H6V3H4' />
        <path d='M20,6l-1,7H6' />
        <g className={classNames(styles.arrow, animation.arrow)}>
            <polyline points='16,7.5 13,10.5 10,7.5 ' />
            <line x1='13' y1='10.5' x2='13' y2='1.5' />
        </g>
    </svg>
);

type Props = {
    className?: string;
};